// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__l3FpO","header":"MessagesList_header__2cBBi","chat":"MessagesList_chat__2lmR9"};